import { render, staticRenderFns } from "./GuidelineItem.vue?vue&type=template&id=9283d66e&scoped=true&"
import script from "./GuidelineItem.vue?vue&type=script&lang=ts&"
export * from "./GuidelineItem.vue?vue&type=script&lang=ts&"
import style0 from "./GuidelineItem.vue?vue&type=style&index=0&id=9283d66e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9283d66e",
  null
  
)

export default component.exports